<template>
<div>
  <br><br>
  <p style="text-align: center;">Authentication successful. Please wait for redirection.</p>
  <loading></loading>
</div>
</template>
<script>
import { setIdToken, setAccessToken } from '../utils/auth';
import Loading from '@/components/Loading';
import { setTimeout } from 'timers';
export default {
  name: '',
  components: { Loading },
  mounted() {
    setTimeout(() => {
      setAccessToken();
      setIdToken();
      window.location.href = '/';
    }, 1000)
  },
};
</script>